class DeliveryTimer {
  constructor() {
    this.timerInterval = null;
    if (document.querySelector('.delivery-timer')) {
      this.initTimer();
    }
  }

  initTimer() {
    // Clear any existing interval to prevent duplicates
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.updateDeliveryTimer();
    this.timerInterval = setInterval(() => this.updateDeliveryTimer(), 1000);
  }

  updateDeliveryTimer() {
    const wrapper = document.querySelector('.delivery-timer');
    const timerElement = document.querySelector('.timer');

    // Safety check - if elements don't exist, clean up and exit
    if (!wrapper || !timerElement) {
      this.cleanup();
      return;
    }

    const now = new Date();
    const targetTime = new Date(now);
    targetTime.setUTCHours(12, 0, 0, 0);

    if (now.getUTCHours() >= 12) {
      targetTime.setUTCDate(targetTime.getUTCDate() + 1);
      wrapper.classList.remove('before_noon');
      wrapper.classList.add('after_noon');
    } else {
      wrapper.classList.remove('after_noon');
      wrapper.classList.add('before_noon');
    }

    const diff = targetTime.getTime() - now.getTime();

    const hours = this.formatTimeUnit(Math.floor(diff / (1000 * 60 * 60)));
    const minutes = this.formatTimeUnit(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = this.formatTimeUnit(Math.floor((diff % (1000 * 60)) / 1000));

    timerElement.innerHTML = `${hours} : ${minutes} : ${seconds}`;
  }

  formatTimeUnit(unit) {
    return unit < 10 ? '0' + unit : unit;
  }

  cleanup() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  disconnectedCallback() {
    this.cleanup();
  }
}

class MainOfferWu18233 extends HTMLElement {
  constructor() {
    super();
    this.inputs = null;
    this.submitButton = null;
    this.subscriptionToggle = null;
    this.giftRows = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Cache DOM elements
    this.inputs = this.querySelectorAll('input[name="offer-quantity"]');
    this.submitButton = this.querySelector('#offer-submit-button');
    this.subscriptionToggle = document.querySelector('#subscription-toggle');
    this.giftRows = this.querySelectorAll('.offer-gifts_row');

    // Restore saved selection from sessionStorage
    this.restoreSelection();

    // Setup event listeners
    this.setupEventListeners();

    // Initial updates
    this.updatePrices();
    this.updateGiftDisplay();

    // Reset button to initial state
    this.resetButton();
  }

  setupEventListeners() {
    // Update prices and gifts on input change
    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updatePrices();
        this.updateGiftDisplay();
      });
    });

    // Update prices when subscription toggle changes
    if (this.subscriptionToggle) {
      this.subscriptionToggle.addEventListener('change', () => {
        this.updatePrices();
        // Save subscription state to sessionStorage
        sessionStorage.setItem('main-offer-wu-18233-subscription', this.subscriptionToggle.checked);
      });
    }

    // Handle submit button click
    if (this.submitButton) {
      this.submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleCheckout();
      });
    }
  }

  getActiveInput() {
    return this.querySelector('input[name="offer-quantity"]:checked');
  }

  updatePrices() {
    const activeInput = this.getActiveInput();
    if (!activeInput) return;

    const priceDefault = activeInput.dataset.priceDefault;
    const subPriceDiscounted = activeInput.dataset.subPriceDiscounted;
    const otpPriceDiscounted = activeInput.dataset.onetimePriceDiscounted;
    const subDiscountPercent = activeInput.dataset.subDiscountPercent;
    const otpDiscountPercent = activeInput.dataset.onetimeDiscountPercent;

    // Check if subscription is enabled
    const isSubscription = this.subscriptionToggle && this.subscriptionToggle.checked;
    const currentDiscountPercent = isSubscription ? subDiscountPercent : otpDiscountPercent;

    // Update button prices based on subscription state
    const priceDiscountedEl = this.querySelector('.js--price-discounted');
    const priceDefaultEl = this.querySelector('.js--price-default');
    const priceDefaultWrapper = this.querySelector('.js--price-default-wrapper');

    if (priceDiscountedEl) {
      priceDiscountedEl.textContent = isSubscription ? subPriceDiscounted : otpPriceDiscounted;
    }

    // Show/hide strikethrough price and separator based on discount
    if (priceDefaultEl && priceDefaultWrapper) {
      if (currentDiscountPercent && parseFloat(currentDiscountPercent) > 0) {
        priceDefaultEl.textContent = priceDefault;
        priceDefaultWrapper.style.display = '';
      } else {
        priceDefaultWrapper.style.display = 'none';
      }
    }

    // Update all discount badges based on subscription state
    this.updateDiscountBadges(isSubscription);
  }

  updateDiscountBadges(isSubscription) {
    // Get all quantity inputs
    const quantityInputs = this.querySelectorAll('input[name="offer-quantity"]');

    quantityInputs.forEach((input) => {
      const subPercent = input.dataset.subDiscountPercent;
      const otpPercent = input.dataset.onetimeDiscountPercent;
      const subPriceDiscounted = input.dataset.subPriceDiscounted;
      const otpPriceDiscounted = input.dataset.onetimePriceDiscounted;
      const intervalDays = input.dataset.intervalDays;

      const discountToShow = isSubscription ? subPercent : otpPercent;
      const priceToShow = isSubscription ? subPriceDiscounted : otpPriceDiscounted;

      // Find the corresponding label
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        // Update discount badge - hide if discount is 0
        const badgeWrapper = label.querySelector('.offer-block__center');
        const badge = label.querySelector('.offer-block__badge-relative');

        if (badge) {
          if (discountToShow && discountToShow !== '0' && parseFloat(discountToShow) > 0) {
            badge.textContent = `Save ${discountToShow}%`;
            if (badgeWrapper) {
              badgeWrapper.style.display = '';
            }
          } else {
            // Hide badge wrapper when discount is 0
            if (badgeWrapper) {
              badgeWrapper.style.display = 'none';
            }
          }
        }

        // Calculate and update price per day
        const pricePerDay = label.querySelector('.offer-block__price-per-day');
        if (pricePerDay && priceToShow && intervalDays) {
          const pricePerDayValue = this.calculatePricePerDay(priceToShow, intervalDays);
          pricePerDay.textContent = `${pricePerDayValue}/day`;
        }
      }
    });
  }

  calculatePricePerDay(priceString, intervalDays) {
    // Remove $ and any other non-numeric characters except decimal point
    const priceValue = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    const days = parseInt(intervalDays);

    if (isNaN(priceValue) || isNaN(days) || days === 0) {
      return '$0.00';
    }

    const perDay = priceValue / days;
    return `$${perDay.toFixed(2)}`;
  }

  updateGiftDisplay() {
    const activeInput = this.getActiveInput();
    if (!activeInput) return;

    const quantity = activeInput.value;

    // Hide all gift rows
    this.giftRows.forEach((row) => {
      row.style.display = 'none';
    });

    // Show only the active quantity's gift row
    const activeRow = this.querySelector(`.offer-gifts-row-${quantity}`);
    if (activeRow) {
      activeRow.style.display = 'flex';
    }
  }

  saveSelection() {
    const activeInput = this.getActiveInput();
    if (activeInput && activeInput.id) {
      sessionStorage.setItem('main-offer-wu-18233-selected', activeInput.id);
    }
  }

  restoreSelection() {
    const savedId = sessionStorage.getItem('main-offer-wu-18233-selected');
    if (savedId) {
      const savedInput = this.querySelector(`#${savedId}`);
      if (savedInput) {
        savedInput.checked = true;
        // Trigger change event to update prices and gifts
        savedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Restore subscription toggle state (default to checked if not saved)
    const savedSubscriptionState = sessionStorage.getItem('main-offer-wu-18233-subscription');
    if (this.subscriptionToggle) {
      if (savedSubscriptionState !== null) {
        this.subscriptionToggle.checked = savedSubscriptionState === 'true';
      } else {
        this.subscriptionToggle.checked = true; // Default to subscription enabled
      }
    }
  }

  resetButton() {
    // Reset submit button: enabled, text visible, spinner hidden
    if (this.submitButton) {
      this.submitButton.disabled = false;
      const spinner = this.submitButton.querySelector('.loading__spinner');
      const buttonText = this.submitButton.querySelector('.picker-submit_btn-text');
      if (spinner) {
        spinner.classList.add('hidden');
      }
      if (buttonText) {
        buttonText.classList.remove('hidden');
      }
    }
  }

  async clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.ok;
    } catch (error) {
      console.error('Error clearing cart:', error);
      return false;
    }
  }

  async addToCart(items, attributes = {}) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items, attributes }),
      });
      return response.ok;
    } catch (error) {
      console.error('Error adding to cart:', error);
      return false;
    }
  }

  async processCheckout(options) {
    const { button, sellingPlanId = null, discountPercent, hideButtonText = false } = options;

    const activeInput = this.getActiveInput();
    if (!activeInput) return;

    // Extract data from active input
    const variantId = activeInput.dataset.variantId;
    const giftVariantIds = activeInput.dataset.giftVariantIds;
    const giftCode = activeInput.dataset.giftCode;
    const quantity = activeInput.value;
    const offerVersion = activeInput.dataset.offerVersion;
    const variantTitle = activeInput.dataset.variantTitle;

    // Get UI elements
    const spinner = button.querySelector('.loading__spinner');
    const buttonText = button.querySelector('.picker-submit_btn-text');

    // Save selection to sessionStorage
    this.saveSelection();

    // Disable button and show loading state
    button.disabled = true;
    if (spinner) spinner.classList.remove('hidden');
    if (hideButtonText && buttonText) buttonText.classList.add('hidden');

    // Clear cart
    await this.clearCart();

    // Prepare main item
    const mainItem = {
      id: variantId,
      quantity: parseInt(quantity),
    };

    // Add selling plan if provided (subscription only)
    if (sellingPlanId) {
      mainItem.selling_plan = sellingPlanId;
    }

    const items = [mainItem];

    // Add gift variants if they exist
    if (giftVariantIds) {
      const giftIds = giftVariantIds.split(',').filter((id) => id.trim());
      giftIds.forEach((giftId) => {
        items.push({
          id: giftId.trim(),
          quantity: 1,
        });
      });
    }

    // Prepare order attributes
    const attributes = {
      'Full-Price-Offer': offerVersion || '',
      'offer-discount': discountPercent || '',
      dog1_weight: variantTitle,
    };

    // Add items to cart with attributes
    const success = await this.addToCart(items, attributes);

    if (success) {
      // Apply discount code if exists and redirect to checkout
      if (giftCode && giftCode.trim()) {
        window.location.href = `/checkout?discount=${giftCode}`;
      } else {
        window.location.href = '/checkout';
      }
    } else {
      // Re-enable button and hide loading state
      button.disabled = false;
      if (spinner) spinner.classList.add('hidden');
      if (hideButtonText && buttonText) buttonText.classList.remove('hidden');
      this.updatePrices();
      alert('There was an error adding items to cart. Please try again.');
    }
  }

  async handleCheckout() {
    const activeInput = this.getActiveInput();
    if (!activeInput) return;

    // Check if subscription is enabled
    const isSubscription = this.subscriptionToggle && this.subscriptionToggle.checked;

    const checkoutOptions = {
      button: this.submitButton,
      discountPercent: isSubscription
        ? activeInput.dataset.subDiscountPercent
        : activeInput.dataset.onetimeDiscountPercent,
      hideButtonText: true,
    };

    // Add selling plan only if subscription is enabled
    if (isSubscription) {
      checkoutOptions.sellingPlanId = activeInput.dataset.sellingPlanId;
    }

    await this.processCheckout(checkoutOptions);
  }
}

customElements.define('main-offer-wu-18233', MainOfferWu18233);

// Store timer instance globally for cleanup
let deliveryTimerInstance = null;

document.addEventListener('DOMContentLoaded', () => {
  deliveryTimerInstance = new DeliveryTimer();
});

// Clean up timer on page unload to prevent memory leaks
window.addEventListener('beforeunload', () => {
  if (deliveryTimerInstance) {
    deliveryTimerInstance.cleanup();
    deliveryTimerInstance = null;
  }
});

// Handle back/forward cache restoration (when user navigates back from checkout)
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    // Page was restored from bfcache, reset button
    const offerElement = document.querySelector('main-offer-wu-18233');
    if (offerElement && offerElement.resetButton) {
      offerElement.resetButton();
    }
  }
});

class DogSizeSelector extends HTMLElement {
  static initialized = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Cache DOM references - only for buttons in this instance
    this.buttons = this.querySelectorAll('.dog-size-selector__button');
    this.offerElement = document.querySelector('main-offer-wu-18233');

    // Restore saved dog size if exists (only run once for first instance)
    if (!DogSizeSelector.initialized) {
      this.restoreDogSize();
      DogSizeSelector.initialized = true;
    }

    // Setup event listeners
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Handle button clicks
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleDogSizeChange(button);
      });
    });
  }

  handleDogSizeChange(button) {
    const dogSize = button.dataset.size;
    const carouselType = button.dataset.carousel;

    // Update active button state for ALL dog size selectors (main content and popup)
    const allButtons = document.querySelectorAll('.dog-size-selector__button');
    allButtons.forEach((btn) => {
      if (btn.dataset.size === dogSize) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Save to sessionStorage
    sessionStorage.setItem('main-offer-wu-18233-dogsize', dogSize);

    // Update URL weight parameter
    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set('weight', dogSize);
    window.history.replaceState({}, '', currentURL.toString());

    // Switch carousel
    this.switchCarousel(carouselType);

    // Update all picker data
    this.updatePickerData(button);
  }

  switchCarousel(carouselType) {
    // Get main content carousels only
    const sbCarousel = document.querySelector('.offer-content__left .offer-carousel-sb');
    const lbCarousel = document.querySelector('.offer-content__left .offer-carousel-lb');

    // Return if carousels don't exist (dogweight_selector is false)
    if (!sbCarousel || !lbCarousel) return;

    // Show/hide based on type
    if (carouselType === 'sb') {
      sbCarousel.classList.remove('hidden');
      lbCarousel.classList.add('hidden');
    } else if (carouselType === 'lb') {
      sbCarousel.classList.add('hidden');
      lbCarousel.classList.remove('hidden');
    }

    // Force carousel to recalculate dimensions
    // Wait a bit for CSS transition to start, then trigger recalculation
    setTimeout(() => {
      // Dispatch resize event to force carousel recalculation
      window.dispatchEvent(new Event('resize'));

      // Reinitialize active carousel
      const activeCarousel = carouselType === 'sb' ? sbCarousel : lbCarousel;
      const carouselElement = activeCarousel.querySelector('carousel-component');
      if (carouselElement && typeof carouselElement.init === 'function') {
        carouselElement.init();
      }
    }, 50);
  }

  updatePickerData(button) {
    // Get data arrays from the button
    const variantId = button.dataset.variantId;
    const variantTitle = button.dataset.variantTitle;
    const pricesArray = button.dataset.prices.split(',');
    const subDiscountedArray = button.dataset.subDiscounted.split(',');
    const otpDiscountedArray = button.dataset.otpDiscounted.split(',');
    const subPercentArray = button.dataset.subPercent.split(',');
    const otpPercentArray = button.dataset.otpPercent.split(',');
    const discountDisplayArray = button.dataset.discountDisplay.split(',');
    const sellingPlansArray = button.dataset.sellingPlans.split(',');
    const intervalsArray = button.dataset.intervals.split(',');
    const quantitiesArray = button.dataset.quantities.split(',');

    // Check if subscription is enabled
    const subscriptionToggle = document.querySelector('#subscription-toggle');
    const isSubscription = subscriptionToggle && subscriptionToggle.checked;

    // Get all quantity inputs
    const quantityInputs = document.querySelectorAll('input[name="offer-quantity"]');

    quantityInputs.forEach((input, index) => {
      // Update data attributes
      input.dataset.variantId = variantId;
      input.dataset.variantTitle = variantTitle.replaceAll(' ', '');
      input.dataset.priceDefault = this.formatMoney(pricesArray[index]);
      input.dataset.subPriceDiscounted = this.formatMoney(subDiscountedArray[index]);
      input.dataset.onetimePriceDiscounted = this.formatMoney(otpDiscountedArray[index]);
      input.dataset.subDiscountPercent = subPercentArray[index];
      input.dataset.onetimeDiscountPercent = otpPercentArray[index];
      input.dataset.sellingPlanId = sellingPlansArray[index];
      input.dataset.intervalDays = intervalsArray[index];
      input.dataset.quantity = quantitiesArray[index];

      // Update visual display on the label
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        // Update days supply text
        const daysSupplyElement = label.querySelector('.offer-block__days-supply');
        if (daysSupplyElement && intervalsArray[index]) {
          const days = parseInt(intervalsArray[index]);
          const dayWord = days === 1 ? 'Day' : 'Days';
          daysSupplyElement.textContent = `${days} ${dayWord} Supply`;
        }

        // Update discount badge based on subscription state
        const badgeWrapper = label.querySelector('.offer-block__center');
        const discountBadge = label.querySelector('.offer-block__badge-relative');
        if (discountBadge) {
          const discountToShow = isSubscription ? subPercentArray[index] : otpPercentArray[index];
          if (discountToShow && parseFloat(discountToShow) > 0) {
            discountBadge.textContent = `${discountToShow}% OFF`;
            if (badgeWrapper) {
              badgeWrapper.style.display = '';
            }
          } else {
            // Hide badge wrapper when discount is 0
            if (badgeWrapper) {
              badgeWrapper.style.display = 'none';
            }
          }
        }

        // Calculate and update price per day based on subscription state
        const pricePerDay = label.querySelector('.offer-block__price-per-day');
        if (pricePerDay && intervalsArray[index]) {
          const priceToShow = isSubscription
            ? this.formatMoney(subDiscountedArray[index])
            : this.formatMoney(otpDiscountedArray[index]);
          const pricePerDayValue = this.calculatePricePerDay(priceToShow, intervalsArray[index]);
          pricePerDay.textContent = `${pricePerDayValue}/day`;
        }
      }
    });

    // Trigger price update on the main offer element
    if (this.offerElement && this.offerElement.updatePrices) {
      this.offerElement.updatePrices();
    }
  }

  calculatePricePerDay(priceString, intervalDays) {
    // Remove $ and any other non-numeric characters except decimal point
    const priceValue = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    const days = parseInt(intervalDays);

    if (isNaN(priceValue) || isNaN(days) || days === 0) {
      return '$0.00';
    }

    const perDay = priceValue / days;
    return `$${perDay.toFixed(2)}`;
  }

  formatMoney(cents) {
    // Validate input
    if (cents === undefined || cents === null || cents === '') {
      console.warn('formatMoney: Invalid cents value provided:', cents);
      return '$0.00';
    }

    // Convert cents to dollars and format
    const parsedCents = parseInt(cents);

    // Check if parsing resulted in NaN
    if (isNaN(parsedCents)) {
      console.warn('formatMoney: Could not parse cents value:', cents);
      return '$0.00';
    }

    const dollars = parsedCents / 100;
    return `$${dollars.toFixed(2)}`;
  }

  restoreDogSize() {
    const savedDogSize = sessionStorage.getItem('main-offer-wu-18233-dogsize');
    if (savedDogSize) {
      const savedButton = Array.from(this.buttons).find((btn) => btn.dataset.size === savedDogSize);
      if (savedButton && !savedButton.classList.contains('active')) {
        // Update to saved dog size
        this.handleDogSizeChange(savedButton);
      }
    }
  }
}

customElements.define('dog-size-selector', DogSizeSelector);
